import { container, singleton } from "tsyringe";
import ContributorApi from "api/clapaction/projects/[id]/config/team/[projectTeamId]/ContributorApi";
import ContributorServiceClassToken from "common/resources/injectables/ContributorServiceClassToken";
import ContributorRequestResource from "common/resources/Project/Config/Contributor/ContributorRequestResource";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import toValidationError from "utils/toValidationError";

@singleton()
export default class ContributorService implements ContributorServiceClassToken {
	private api: ContributorApi = container.resolve(ContributorApi);

	/**
	 * @description Check if a contributor exists by a given condition
	 */
	public async existsBy(_where: unknown): Promise<boolean> {
		return true;
	}

	/**
	 * @description Get all by project team id
	 */
	public async getAllByProjectTeamId(projectId: string, projectTeamId: string): Promise<ContributorResponseResource[]> {
		return this.api.getAllByProjectTeamId(projectId, projectTeamId).catch(toValidationError);
	}

	/**
	 * @description Get one by id
	 */
	public async getById(projectId: string, projectTeamId: string, contributorId: string): Promise<ContributorResponseResource> {
		return this.api.getById(projectId, projectTeamId, contributorId).catch(toValidationError);
	}

	/**
	 * @description Download contributor avatar
	 */
	public async downloadAvatar(projectId: string, projectTeamId: string, contributorId: string): Promise<Blob | null> {
		return this.api.downloadAvatar(projectId, projectTeamId, contributorId).catch(() => null);
	}

	/**
	 * @description Create a contributor for a project team
	 */
	public async create(projectId: string, projectTeamId: string, request: ContributorRequestResource, avatar?: File): Promise<ContributorResponseResource> {
		return this.api.create(projectId, projectTeamId, request, avatar).catch(toValidationError);
	}

	/**
	 * @description Update a contributor for a project team
	 */
	public async update(projectId: string, projectTeamId: string, contributorId: string, request: ContributorRequestResource, avatar?: File): Promise<ContributorResponseResource> {
		return this.api.update(projectId, projectTeamId, contributorId, request, avatar).catch(toValidationError);
	}

	/**
	 * @description Delete a contributor for a project team
	 */
	public async delete(projectId: string, projectTeamId: string, contributorId: string): Promise<void> {
		return this.api.delete(projectId, projectTeamId, contributorId).catch(toValidationError);
	}
}
